<template>
  <ListSearchable
    ref="list"
    :base-url="url"
    class="d-flex flex-column"
    style="height: 300px"
    :input="{placeholder: 'Search', clearable: true, 'class': ['mb-2']}"
    #default="{item, isCurrent, select}"
  >
    <div
      @click="onClick(select, item)"
      :class="{'item-list__item_current': isCurrent}"
      class="item-list__item cursor-pointer user-select-none"
    >
      <div
        v-if="hasTags(item)"
        class="d-flex flex-wrap gap-1 mb-1">
        <div
          v-for="{title, is_system} in itemTags(item)"
          class="badge text-uppercase"
          :class="[is_system ? 'badge-info' : 'badge-secondary']"
        >{{ title }}</div>
      </div>
      <div class="message-content line-height-15">{{ getContent(item) }}</div>
    </div>
  </ListSearchable>
</template>

<script>
import ListSearchable from "../../shared/approved-message/list-searchable.vue";
import {isFilled} from "../../../helpers";

export default {
  components: {
    ListSearchable,
  },

  props: {
    url: String
  },

  methods: {
    refresh() {
      this.$refs.list.refresh();
    },

    /**
     * @param item
     * @return {string}
     */
    getContent(item) {
      return _.get(item, 'model.content', '');
    },

    /**
     * @param {Function} select
     * @param {Object} item
     * @emits select
     */
    onClick(select, item) {
      select(item);
      this.$emit('select', item);
    },

    /**
     * @param {Object} item
     * @return {Array}
     */
    itemTags(item) {
      return _.get(item, 'model.tags', []);
    },

    /**
     * @param {Object} item
     * @return {boolean}
     */
    hasTags(item) {
      return isFilled(this.itemTags(item));
    },
  },
}
</script>
